module.exports = __webpack_public_path__ + "img/responsibility_1.bcbd632d.png";